import _extends from "@babel/runtime/helpers/extends";
import React, { memo, useState, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Text, Advice, Input, Modal } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from "../../lib/Web5Context";
import { breakLines } from "../../utils/string";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'ModalConfirm');
const ModalConfirm = _ref => {
  let {
    onConfirm,
    onCancel,
    isOpen,
    title,
    description,
    advice,
    writeXToConfirm,
    passPhrase,
    confirmText,
    isConfirmLoading
  } = _ref;
  const {
    t
  } = useWeb5Context();
  const [value, setValue] = useState('');
  const classes = useStyles();
  const onValueChange = useCallback(value => setValue(value || ''), [setValue]);
  const handleOnConfirm = useCallback(() => {
    if ((value === null || value === void 0 ? void 0 : value.toLowerCase()) !== passPhrase.toLowerCase()) return;
    setValue('');
    onConfirm && onConfirm();
  }, [value, passPhrase, onConfirm]);
  const handleOnCancel = useCallback(() => {
    onCancel && onCancel();
    setValue();
  }, [onCancel]);
  const overrides = useMemo(() => ({
    confirmButton: {
      className: (value === null || value === void 0 ? void 0 : value.toLowerCase()) !== passPhrase.toLowerCase() ? ['fm-button__disabled'] : [],
      isDisabled: !((value === null || value === void 0 ? void 0 : value.toLowerCase()) === passPhrase.toLowerCase())
    }
  }), [value, passPhrase]);
  const modalProps = useMemo(() => ({
    isOpen,
    onRequestClose: handleOnCancel,
    onCancel: handleOnCancel,
    onConfirm: handleOnConfirm,
    title,
    cancelText: t('cfm_action_cancel'),
    confirmText,
    className: classes.root,
    overlayClassName: classes.overlay,
    isConfirmLoading
  }), [isOpen, handleOnCancel, handleOnConfirm, title, t, confirmText, classes.root, classes.overlay, isConfirmLoading]);
  return /*#__PURE__*/React.createElement(Modal, _extends({}, modalProps, {
    overrides: overrides
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.confirmContent
  }, description && /*#__PURE__*/React.createElement(Text, {
    className: classes.confirmText
  }, breakLines(description)), advice && /*#__PURE__*/React.createElement(Advice, {
    showCollapse: false,
    className: classes.confirmAdvice,
    type: "warning",
    showIcon: true
  }, breakLines(advice)), /*#__PURE__*/React.createElement(Text, null, t(writeXToConfirm, [passPhrase.toUpperCase()]))), /*#__PURE__*/React.createElement("div", {
    className: classes.confirmInput
  }, /*#__PURE__*/React.createElement(Input, {
    placeholder: t('placeholder_text_field'),
    value: value,
    onChange: onValueChange
  })));
};
process.env.NODE_ENV !== "production" ? ModalConfirm.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  onCancel: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired
} : void 0;
export default /*#__PURE__*/memo(ModalConfirm);